import Cookies from 'js-cookie';

export async function createSessionCookie(token) {
    try {
        Cookies.set('user_session', token, {
            secure: true,
            sameSite: 'strict',
            path: '/'
        });

        return { ok: true };
    } catch (err) {
        return { ok: false, message: "Er ging iets mis bij het aanmaken van de sessie." };
    }
}